export enum KnowledgeBaseLinksEnum {
  ContinueCloningPage = 'https://help.demostack.com/en/articles/6661148-continue-cloning',
}
